<template>
  <div class="margin-container">
    <div class="margin-container-item">
      <single-input
        :value.sync="leftMargin"
        inputSuffixs="px"
        :step="1"
      />
      <span class="tips">左右间距</span>
    </div>
    <div class="margin-container-item">
      <single-input
        :value.sync="topMargin"
        inputSuffixs="px"
        :step="1"
      />
      <span class="tips">上下间距</span>
    </div>
  </div>
</template>
<script>
import complexSetMixin from "./complexSetMixin.js"
export default {
  mixins: [complexSetMixin()],
  computed: {
    leftMargin: {
      get() {
        return this.configData.leftMargin
      },
      set(newVal) {
        this.configData.leftMargin = newVal
      }
    },
    topMargin: {
      get() {
        return this.configData.topMargin
      },
      set(newVal) {
        this.configData.topMargin = newVal
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-container {
  display: flex;
  gap: 8px;
  .margin-container-item {
    flex: 1;
    .tips {
      display: block;
      padding: 4px 0 0 12px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.6);
    }
  }
}
</style>